import React from 'react';
export function InfoCircleIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.008 22h-.016a10 10 0 11.016-20h.015a10 10 0 01-.015 20zm0-18a8 8 0 00-.012 16h.012a8 8 0 10.011-16h-.011z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.006 9.005a1 1 0 100-2 1 1 0 000 2z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.006 16.007a1 1 0 011-1h2a1 1 0 110 2h-2a1 1 0 01-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.006 11.006a1 1 0 011-1h1a1 1 0 011 1.002l-.01 5a1 1 0 11-2-.003l.008-4a1 1 0 01-.998-1z"
  }));
}